import React, { useEffect, useState } from "react";
import OtpInput from "react-otp-input";
import { ArrowLeft } from "lucide-react";
import styles from "./ExternalLogin.module.scss";

const formatTimer = (seconds) => {
  const s = Math.max(0, seconds);
  return `00:${s < 10 ? "0" : ""}${s}`;
};

const OtpStep = ({
  phoneNumber,
  otp,
  onOtpChange,
  otpLength,
  resendSeconds,
  onResend,
  onVerify,
  onBack,
  isSubmitting,
  errorMessage,
  termsHref,
}) => {
  const [timer, setTimer] = useState(resendSeconds);
  const [tncAccepted, setTncAccepted] = useState(true);

  useEffect(() => {
    setTimer(resendSeconds);
  }, [resendSeconds]);

  useEffect(() => {
    if (timer <= 0) return undefined;
    const t = setTimeout(() => setTimer((v) => v - 1), 1000);
    return () => clearTimeout(t);
  }, [timer]);

  const canResend = timer <= 0;
  const isOtpFilled = otp?.length === otpLength;
  const canVerify = isOtpFilled && tncAccepted && !isSubmitting;

  return (
    <div className={`${styles.wrapper} ${styles.wrapperOtp}`}>
      <div className={styles.otpSection}>
        <button
          type="button"
          className={styles.backButton}
          onClick={onBack}
          aria-label="Go back"
        >
          <ArrowLeft size={22} />
        </button>

        <h1 className={styles.otpHeading}>Enter verification code</h1>
        <p className={styles.otpSubHeading}>
          6 digit OTP has been sent to +91 {phoneNumber}
        </p>

        <OtpInput
          inputType="number"
          value={otp}
          onChange={onOtpChange}
          numInputs={otpLength}
          containerStyle={styles.otpInputContainer}
          renderInput={(props) => (
            <input {...props} className={styles.otpInputBox} />
          )}
        />

        {errorMessage ? (
          <div className={styles.errorText} role="alert">
            {errorMessage}
          </div>
        ) : null}

        <div className={styles.timerRow}>
          <div className={styles.timer}>{formatTimer(timer)}</div>
          <div className={styles.resendRow}>
            Didn't receive the code?
            <button
              type="button"
              className={`${styles.resendButton} ${
                canResend ? styles.resendButtonActive : ""
              }`}
              disabled={!canResend}
              onClick={() => {
                onResend();
                setTimer(resendSeconds);
              }}
            >
              Resend now
            </button>
          </div>
        </div>

        <label className={styles.tncRow}>
          <input
            type="checkbox"
            className={styles.tncCheckbox}
            checked={tncAccepted}
            onChange={(e) => setTncAccepted(e.target.checked)}
          />
          <span>
            I agree to Hyperpure{" "}
            {termsHref ? (
              <a href={termsHref} className={styles.tncLink}>
                terms &amp; conditions
              </a>
            ) : (
              <span className={styles.tncLink}>terms &amp; conditions</span>
            )}
          </span>
        </label>
      </div>

      <div className={styles.footer}>
        <button
          type="button"
          className={styles.primaryButton}
          disabled={!canVerify}
          onClick={onVerify}
        >
          {isSubmitting ? "Verifying..." : "Verify"}
        </button>
      </div>
    </div>
  );
};

export default OtpStep;
